// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/bulkaction/v1/bulkaction.proto" (package "c1.api.bulkaction.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppManagedStateBindingRef } from "../../app/v1/app_managed";
import { AppResourceRef } from "../../app/v1/app_resource";
import { AppUserRef } from "../../app/v1/app_user";
import { AppEntitlementUserBindingRef } from "../../app/v1/app_refs";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { AppRef } from "../../app/v1/app";
import { AppUserType } from "../../app/v1/app_user";
import { AppUserSearchFilter } from "../../app/v1/app_user";
import { AppResourceSearchFilter } from "../../app/v1/app_resource";
import { AppManagedStateBindingSearchFilter } from "../../app/v1/app_managed";
import { AppEntitlementUserBindingSearchFilter } from "../../app/v1/app_entitlement";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppEntitlement } from "../../app/v1/app_entitlement";
import { AppEntitlementSearchFilter } from "../../app/v1/app_entitlement";
import { AppSearchFilter } from "../../app/v1/app";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionGetRequest
 */
export interface BulkActionGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionDeleteRequest
 */
export interface BulkActionDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListRequest
 */
export interface BulkActionListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListResponse
 */
export interface BulkActionListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.bulkaction.v1.BulkAction list = 1;
     */
    list: BulkAction[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionArgs
 */
export interface BulkActionArgs {
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "assignAppOwnersAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.AssignAppOwnersAction assign_app_owners_action = 1;
         */
        assignAppOwnersAction: AssignAppOwnersAction;
    } | {
        oneofKind: "setAppEntitlementAccessRequestsAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction set_app_entitlement_access_requests_action = 2;
         */
        setAppEntitlementAccessRequestsAction: SetAppEntitlementAccessRequestsAction;
    } | {
        oneofKind: "createRevokeTicketsAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CreateRevokeTicketsAction create_revoke_tickets_action = 3;
         */
        createRevokeTicketsAction: CreateRevokeTicketsAction;
    } | {
        oneofKind: "setAppEntitlementProvisionPolicyAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction set_app_entitlement_provision_policy_action = 4;
         */
        setAppEntitlementProvisionPolicyAction: SetAppEntitlementProvisionPolicyAction;
    } | {
        oneofKind: "assignAppEntitlementOwnersAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction assign_app_entitlement_owners_action = 5;
         */
        assignAppEntitlementOwnersAction: AssignAppEntitlementOwnersAction;
    } | {
        oneofKind: "setAppUserAccountTypeAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppUserAccountTypeAction set_app_user_account_type_action = 6;
         */
        setAppUserAccountTypeAction: SetAppUserAccountTypeAction;
    } | {
        oneofKind: "assignAppResourceOwnersAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.AssignAppResourceOwnersAction assign_app_resource_owners_action = 7;
         */
        assignAppResourceOwnersAction: AssignAppResourceOwnersAction;
    } | {
        oneofKind: "setGrantExpirationAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetGrantExpirationAction set_grant_expiration_action = 8;
         */
        setGrantExpirationAction: SetGrantExpirationAction;
    } | {
        oneofKind: "removeGrantExpirationAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.RemoveGrantExpirationAction remove_grant_expiration_action = 9;
         */
        removeGrantExpirationAction: RemoveGrantExpirationAction;
    } | {
        oneofKind: "promoteAppManagedStateBindingAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction promote_app_managed_state_binding_action = 10;
         */
        promoteAppManagedStateBindingAction: PromoteAppManagedStateBindingAction;
    } | {
        oneofKind: "setAppUserOwnerAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppUserOwnerAction set_app_user_owner_action = 11;
         */
        setAppUserOwnerAction: SetAppUserOwnerAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionCreateRequest
 */
export interface BulkActionCreateRequest {
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionArgs args = 1;
     */
    args?: BulkActionArgs;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkAction
 */
export interface BulkAction {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionArgs args = 2;
     */
    args?: BulkActionArgs;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionState state = 3;
     */
    state: BulkActionState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string created_by_id = 7;
     */
    createdById: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.AssignAppOwnersAction
 */
export interface AssignAppOwnersAction {
    /**
     * A filter to search for apps to assign owners to
     *
     * @generated from protobuf field: c1.api.app.v1.AppSearchFilter filter = 1;
     */
    filter?: AppSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.CatalogIds
 */
export interface CatalogIds {
    /**
     * @generated from protobuf field: repeated string ids = 1;
     */
    ids: string[];
    /**
     * @generated from protobuf field: repeated string preserve_ids = 2;
     */
    preserveIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction
 */
export interface SetAppEntitlementAccessRequestsAction {
    /**
     * A filter to search for app entitlements to update
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchFilter filter = 1;
     */
    filter?: AppEntitlementSearchFilter;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement update_app_entitlement = 2;
     */
    updateAppEntitlement?: AppEntitlement;
    /**
     * A comma sepparated list of fields to update from the entitlement. For example: "certify_policy_id,slug"
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 3;
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf oneof: catalogs
     */
    catalogs: {
        oneofKind: "setCatalogIds";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CatalogIds set_catalog_ids = 5;
         */
        setCatalogIds: CatalogIds;
    } | {
        oneofKind: "ignoreCatalogIds";
        /**
         * @generated from protobuf field: bool ignore_catalog_ids = 8;
         */
        ignoreCatalogIds: boolean;
    } | {
        oneofKind: "addCatalogIds";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CatalogIds add_catalog_ids = 9;
         */
        addCatalogIds: CatalogIds;
    } | {
        oneofKind: "removeCatalogIds";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CatalogIds remove_catalog_ids = 10;
         */
        removeCatalogIds: CatalogIds;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.CreateRevokeTicketsAction
 */
export interface CreateRevokeTicketsAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1;
     */
    filter?: AppEntitlementUserBindingSearchFilter;
    /**
     * @generated from protobuf field: string reason = 2;
     */
    reason: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction
 */
export interface SetAppEntitlementProvisionPolicyAction {
    /**
     * A filter to search for app entitlements to update
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchFilter filter = 1;
     */
    filter?: AppEntitlementSearchFilter;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement update_app_entitlement = 2;
     */
    updateAppEntitlement?: AppEntitlement;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetGrantExpirationAction
 */
export interface SetGrantExpirationAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1;
     */
    filter?: AppEntitlementUserBindingSearchFilter;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deprovision_at = 2;
     */
    deprovisionAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.RemoveGrantExpirationAction
 */
export interface RemoveGrantExpirationAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1;
     */
    filter?: AppEntitlementUserBindingSearchFilter;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction
 */
export interface PromoteAppManagedStateBindingAction {
    /**
     * A filter to search for app managed state bindings to promote
     *
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingSearchFilter filter = 1;
     */
    filter?: AppManagedStateBindingSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction
 */
export interface AssignAppEntitlementOwnersAction {
    /**
     * A filter to search for app entitlements to update
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchFilter filter = 1;
     */
    filter?: AppEntitlementSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.AssignAppResourceOwnersAction
 */
export interface AssignAppResourceOwnersAction {
    /**
     * A filter to search for resources to assign owners to
     *
     * @generated from protobuf field: c1.api.app.v1.AppResourceSearchFilter filter = 1;
     */
    filter?: AppResourceSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppUserAccountTypeAction
 */
export interface SetAppUserAccountTypeAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserSearchFilter filter = 1;
     */
    filter?: AppUserSearchFilter;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserType update_app_user_type = 2;
     */
    updateAppUserType: AppUserType;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppUserOwnerAction
 */
export interface SetAppUserOwnerAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserSearchFilter filter = 1;
     */
    filter?: AppUserSearchFilter;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionRef
 */
export interface BulkActionRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListItemsRequest
 */
export interface BulkActionListItemsRequest {
    /**
     * @generated from protobuf field: string bulk_action_id = 1;
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListItemsResponse
 */
export interface BulkActionListItemsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.bulkaction.v1.BulkActionItem list = 1;
     */
    list: BulkActionItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsRequest
 */
export interface BulkActionListCompletedItemsRequest {
    /**
     * @generated from protobuf field: string bulk_action_id = 1;
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsResponse
 */
export interface BulkActionListCompletedItemsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.bulkaction.v1.CompletedBulkActionItem list = 1;
     */
    list: CompletedBulkActionItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionItem
 */
export interface BulkActionItem {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string bulk_action_id = 2;
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionItemState state = 4;
     */
    state: BulkActionItemState;
    /**
     * @generated from protobuf field: string error_message = 5;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf oneof: ref
     */
    ref: {
        oneofKind: "appRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppRef app_ref = 9;
         */
        appRef: AppRef;
    } | {
        oneofKind: "appEntitlementRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef app_entitlement_ref = 10;
         */
        appEntitlementRef: AppEntitlementRef;
    } | {
        oneofKind: "appEntitlementUserBindingRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingRef app_entitlement_user_binding_ref = 11;
         */
        appEntitlementUserBindingRef: AppEntitlementUserBindingRef;
    } | {
        oneofKind: "appUserRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUserRef app_user_ref = 12;
         */
        appUserRef: AppUserRef;
    } | {
        oneofKind: "appResourceRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppResourceRef app_resource_ref = 13;
         */
        appResourceRef: AppResourceRef;
    } | {
        oneofKind: "appManagedStateBindingRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 14;
         */
        appManagedStateBindingRef: AppManagedStateBindingRef;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.CompletedBulkActionItem
 */
export interface CompletedBulkActionItem {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string bulk_action_id = 2;
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionItemState state = 4;
     */
    state: BulkActionItemState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 8;
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionItem bulk_action_item = 9;
     */
    bulkActionItem?: BulkActionItem;
}
/**
 * @generated from protobuf enum c1.api.bulkaction.v1.BulkActionState
 */
export enum BulkActionState {
    /**
     * @generated from protobuf enum value: BULK_ACTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * initial state
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * creating bulk action items
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_CREATING = 2;
     */
    CREATING = 2,
    /**
     * processing each bulk action item
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_PROCESSING = 3;
     */
    PROCESSING = 3,
    /**
     * successfully done
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_DONE = 4;
     */
    DONE = 4,
    /**
     * cancelled
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_CANCELED = 5;
     */
    CANCELED = 5,
    /**
     * the entire bulk action errored (usually on creating items) terminal error.
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_ERRORED = 6;
     */
    ERRORED = 6
}
/**
 * @generated from protobuf enum c1.api.bulkaction.v1.BulkActionItemState
 */
export enum BulkActionItemState {
    /**
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * processing
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_IN_PROGRESS = 1;
     */
    IN_PROGRESS = 1,
    /**
     * successfully done
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_DONE = 2;
     */
    DONE = 2,
    /**
     * cancelled
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_CANCELED = 3;
     */
    CANCELED = 3,
    /**
     * terminal error
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_ERRORED = 4;
     */
    ERRORED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionGetRequest$Type extends MessageType<BulkActionGetRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionGetRequest
 */
export const BulkActionGetRequest = new BulkActionGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionDeleteRequest$Type extends MessageType<BulkActionDeleteRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionDeleteRequest
 */
export const BulkActionDeleteRequest = new BulkActionDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListRequest$Type extends MessageType<BulkActionListRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListRequest
 */
export const BulkActionListRequest = new BulkActionListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListResponse$Type extends MessageType<BulkActionListResponse> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BulkAction },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListResponse
 */
export const BulkActionListResponse = new BulkActionListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionArgs$Type extends MessageType<BulkActionArgs> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionArgs", [
            { no: 1, name: "assign_app_owners_action", kind: "message", oneof: "typ", T: () => AssignAppOwnersAction },
            { no: 2, name: "set_app_entitlement_access_requests_action", kind: "message", oneof: "typ", T: () => SetAppEntitlementAccessRequestsAction },
            { no: 3, name: "create_revoke_tickets_action", kind: "message", oneof: "typ", T: () => CreateRevokeTicketsAction },
            { no: 4, name: "set_app_entitlement_provision_policy_action", kind: "message", oneof: "typ", T: () => SetAppEntitlementProvisionPolicyAction },
            { no: 5, name: "assign_app_entitlement_owners_action", kind: "message", oneof: "typ", T: () => AssignAppEntitlementOwnersAction },
            { no: 6, name: "set_app_user_account_type_action", kind: "message", oneof: "typ", T: () => SetAppUserAccountTypeAction },
            { no: 7, name: "assign_app_resource_owners_action", kind: "message", oneof: "typ", T: () => AssignAppResourceOwnersAction },
            { no: 8, name: "set_grant_expiration_action", kind: "message", oneof: "typ", T: () => SetGrantExpirationAction },
            { no: 9, name: "remove_grant_expiration_action", kind: "message", oneof: "typ", T: () => RemoveGrantExpirationAction },
            { no: 10, name: "promote_app_managed_state_binding_action", kind: "message", oneof: "typ", T: () => PromoteAppManagedStateBindingAction },
            { no: 11, name: "set_app_user_owner_action", kind: "message", oneof: "typ", T: () => SetAppUserOwnerAction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionArgs
 */
export const BulkActionArgs = new BulkActionArgs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionCreateRequest$Type extends MessageType<BulkActionCreateRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionCreateRequest", [
            { no: 1, name: "args", kind: "message", T: () => BulkActionArgs }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionCreateRequest
 */
export const BulkActionCreateRequest = new BulkActionCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkAction$Type extends MessageType<BulkAction> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkAction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "args", kind: "message", T: () => BulkActionArgs },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.bulkaction.v1.BulkActionState", BulkActionState, "BULK_ACTION_STATE_"] },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "created_by_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkAction
 */
export const BulkAction = new BulkAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignAppOwnersAction$Type extends MessageType<AssignAppOwnersAction> {
    constructor() {
        super("c1.api.bulkaction.v1.AssignAppOwnersAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.AssignAppOwnersAction
 */
export const AssignAppOwnersAction = new AssignAppOwnersAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CatalogIds$Type extends MessageType<CatalogIds> {
    constructor() {
        super("c1.api.bulkaction.v1.CatalogIds", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^$|^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "preserve_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^$|^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.CatalogIds
 */
export const CatalogIds = new CatalogIds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementAccessRequestsAction$Type extends MessageType<SetAppEntitlementAccessRequestsAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchFilter },
            { no: 2, name: "update_app_entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 5, name: "set_catalog_ids", kind: "message", oneof: "catalogs", T: () => CatalogIds },
            { no: 8, name: "ignore_catalog_ids", kind: "scalar", oneof: "catalogs", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "add_catalog_ids", kind: "message", oneof: "catalogs", T: () => CatalogIds },
            { no: 10, name: "remove_catalog_ids", kind: "message", oneof: "catalogs", T: () => CatalogIds }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction
 */
export const SetAppEntitlementAccessRequestsAction = new SetAppEntitlementAccessRequestsAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRevokeTicketsAction$Type extends MessageType<CreateRevokeTicketsAction> {
    constructor() {
        super("c1.api.bulkaction.v1.CreateRevokeTicketsAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementUserBindingSearchFilter },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.CreateRevokeTicketsAction
 */
export const CreateRevokeTicketsAction = new CreateRevokeTicketsAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementProvisionPolicyAction$Type extends MessageType<SetAppEntitlementProvisionPolicyAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchFilter },
            { no: 2, name: "update_app_entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction
 */
export const SetAppEntitlementProvisionPolicyAction = new SetAppEntitlementProvisionPolicyAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGrantExpirationAction$Type extends MessageType<SetGrantExpirationAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetGrantExpirationAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementUserBindingSearchFilter },
            { no: 2, name: "deprovision_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetGrantExpirationAction
 */
export const SetGrantExpirationAction = new SetGrantExpirationAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGrantExpirationAction$Type extends MessageType<RemoveGrantExpirationAction> {
    constructor() {
        super("c1.api.bulkaction.v1.RemoveGrantExpirationAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementUserBindingSearchFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.RemoveGrantExpirationAction
 */
export const RemoveGrantExpirationAction = new RemoveGrantExpirationAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromoteAppManagedStateBindingAction$Type extends MessageType<PromoteAppManagedStateBindingAction> {
    constructor() {
        super("c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppManagedStateBindingSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction
 */
export const PromoteAppManagedStateBindingAction = new PromoteAppManagedStateBindingAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignAppEntitlementOwnersAction$Type extends MessageType<AssignAppEntitlementOwnersAction> {
    constructor() {
        super("c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction
 */
export const AssignAppEntitlementOwnersAction = new AssignAppEntitlementOwnersAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignAppResourceOwnersAction$Type extends MessageType<AssignAppResourceOwnersAction> {
    constructor() {
        super("c1.api.bulkaction.v1.AssignAppResourceOwnersAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppResourceSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.AssignAppResourceOwnersAction
 */
export const AssignAppResourceOwnersAction = new AssignAppResourceOwnersAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppUserAccountTypeAction$Type extends MessageType<SetAppUserAccountTypeAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppUserAccountTypeAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppUserSearchFilter },
            { no: 2, name: "update_app_user_type", kind: "enum", T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppUserAccountTypeAction
 */
export const SetAppUserAccountTypeAction = new SetAppUserAccountTypeAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppUserOwnerAction$Type extends MessageType<SetAppUserOwnerAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppUserOwnerAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppUserSearchFilter },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppUserOwnerAction
 */
export const SetAppUserOwnerAction = new SetAppUserOwnerAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionRef$Type extends MessageType<BulkActionRef> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionRef
 */
export const BulkActionRef = new BulkActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListItemsRequest$Type extends MessageType<BulkActionListItemsRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListItemsRequest", [
            { no: 1, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListItemsRequest
 */
export const BulkActionListItemsRequest = new BulkActionListItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListItemsResponse$Type extends MessageType<BulkActionListItemsResponse> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListItemsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BulkActionItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListItemsResponse
 */
export const BulkActionListItemsResponse = new BulkActionListItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListCompletedItemsRequest$Type extends MessageType<BulkActionListCompletedItemsRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListCompletedItemsRequest", [
            { no: 1, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsRequest
 */
export const BulkActionListCompletedItemsRequest = new BulkActionListCompletedItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListCompletedItemsResponse$Type extends MessageType<BulkActionListCompletedItemsResponse> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListCompletedItemsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CompletedBulkActionItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsResponse
 */
export const BulkActionListCompletedItemsResponse = new BulkActionListCompletedItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionItem$Type extends MessageType<BulkActionItem> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionItem", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.bulkaction.v1.BulkActionItemState", BulkActionItemState, "BULK_ACTION_ITEM_STATE_"] },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "app_ref", kind: "message", oneof: "ref", T: () => AppRef },
            { no: 10, name: "app_entitlement_ref", kind: "message", oneof: "ref", T: () => AppEntitlementRef },
            { no: 11, name: "app_entitlement_user_binding_ref", kind: "message", oneof: "ref", T: () => AppEntitlementUserBindingRef },
            { no: 12, name: "app_user_ref", kind: "message", oneof: "ref", T: () => AppUserRef },
            { no: 13, name: "app_resource_ref", kind: "message", oneof: "ref", T: () => AppResourceRef },
            { no: 14, name: "app_managed_state_binding_ref", kind: "message", oneof: "ref", T: () => AppManagedStateBindingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionItem
 */
export const BulkActionItem = new BulkActionItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompletedBulkActionItem$Type extends MessageType<CompletedBulkActionItem> {
    constructor() {
        super("c1.api.bulkaction.v1.CompletedBulkActionItem", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.bulkaction.v1.BulkActionItemState", BulkActionItemState, "BULK_ACTION_ITEM_STATE_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "bulk_action_item", kind: "message", T: () => BulkActionItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.CompletedBulkActionItem
 */
export const CompletedBulkActionItem = new CompletedBulkActionItem$Type();
/**
 * @generated ServiceType for protobuf service c1.api.bulkaction.v1.BulkActionService
 */
export const BulkActionService = new ServiceType("c1.api.bulkaction.v1.BulkActionService", [
    { name: "ListBulkAction", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionListRequest, O: BulkActionListResponse },
    { name: "GetBulkAction", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionGetRequest, O: BulkAction },
    { name: "CreateBulkAction", options: { "authz.method": { role: "EDITOR" } }, I: BulkActionCreateRequest, O: BulkAction },
    { name: "DeleteBulkAction", options: { "authz.method": { role: "EDITOR" } }, I: BulkActionDeleteRequest, O: Empty },
    { name: "ListBulkActionItems", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionListItemsRequest, O: BulkActionListItemsResponse },
    { name: "ListCompletedBulkActionItems", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionListCompletedItemsRequest, O: BulkActionListCompletedItemsResponse }
]);
